import { useState } from "react";
import { Send, Check, MessageCircle, ArrowRight } from "lucide-react";
import { createLead, WHATSAPP_LINK } from "../lib/api";
import { toast } from "sonner";

export const ContactForm = ({ source = "contact", page = "/", buttonLabel = "Envoyer le formulaire" }) => {
  const [form, setForm] = useState({ nom: "", email: "", telephone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    if (!form.nom.trim() || !form.email.trim()) {
      toast.error("Nom et email sont requis.");
      return;
    }
    setSubmitting(true);
    try {
      await createLead({ ...form, source, page });
      setDone(true);
      toast.success("Message reçu — réponse sous 24h.");
      setForm({ nom: "", email: "", telephone: "", message: "" });
    } catch (err) {
      toast.error("Une erreur est survenue, réessayez.");
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="card-base text-center" data-testid="contact-success">
        <span className="icon-square mx-auto mb-4">
          <Check size={28} />
        </span>
        <h3 className="title-text text-xl font-bold mb-2">Message reçu.</h3>
        <p className="body-text text-sm mb-6">
          Christophe vous répond sous 24h, directement par email ou WhatsApp.
        </p>
        <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="btn-secondary inline-flex">
          <MessageCircle size={18} /> Continuer sur WhatsApp
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={onSubmit} className="card-base space-y-4" data-testid="contact-form">
      <Field label="Nom" name="nom" value={form.nom} onChange={onChange} required />
      <Field label="Email" name="email" type="email" value={form.email} onChange={onChange} required />
      <Field label="Téléphone" name="telephone" value={form.telephone} onChange={onChange} />
      <Field label="Message" name="message" textarea value={form.message} onChange={onChange} />
      <button
        type="submit"
        className="btn-primary w-full"
        disabled={submitting}
        data-testid="submit-contact-form"
      >
        {submitting ? "Envoi..." : (
          <>
            {buttonLabel} <ArrowRight size={18} />
          </>
        )}
      </button>
      <p className="text-xs body-text flex flex-wrap gap-x-4 gap-y-1 pt-2">
        <span>✓ Réponse sous 24h</span>
        <span>✓ Basé à Genève</span>
      </p>
    </form>
  );
};

const Field = ({ label, name, type = "text", value, onChange, required, textarea }) => (
  <label className="block">
    <span className="text-xs font-semibold uppercase tracking-wider title-text">
      {label} {required && <span className="accent-text">*</span>}
    </span>
    {textarea ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        rows={4}
        data-testid={`field-${name}`}
        className="mt-2 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-[#3ecf8e] focus:ring-2 focus:ring-[#3ecf8e]/20 outline-none transition"
      />
    ) : (
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        data-testid={`field-${name}`}
        className="mt-2 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm focus:border-[#3ecf8e] focus:ring-2 focus:ring-[#3ecf8e]/20 outline-none transition"
      />
    )}
  </label>
);
